import { Middleware } from './store.types';

const storeMiddlewares: Middleware[] = [];

export default storeMiddlewares;
